import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import FormInput from "./FormInput";
import { minDelay, readFileAsArrayBuffer } from "../util";
import Actor from "./Actor";
import LoadingOverlay from './LoadingOverlay';
import { useConfig } from "../ConfigContext";

export default function HearingRequest({ caseData, onHearingRequestComplete }) {
  const {config, error: configError} = useConfig();
  const [processingError, setProcessingError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    control,
    setValue,
    formState: { errors },
    clearErrors,
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      "firstName": caseData.apt_Recipient.firstname,
      "lastName": caseData.apt_Recipient.lastname,
      "email": caseData.apt_Recipient.emailaddress1,
      "emailConfirm": caseData.apt_Recipient.emailaddress1,
      "phone": caseData.apt_Recipient.telephone2,
      "streetAddress": caseData.apt_Recipient.address1_line1,
      "municipality": caseData.apt_Recipient.address1_city,
      "province": caseData.apt_Recipient.address1_stateorprovince,
      "postalCode": caseData.apt_Recipient.address1_postalcode
    },
  });
  const [actor] = watch(['actor']);

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    data.requestMethod = 750290001; // phone / virtual
    data.type = 750290003; // hearing
    data.channel = 750290000; // online

    minDelay(
      fetch(`${config.apiUrl}/cases/${caseData.apt_caseid}/request-review`, {
        method: "POST",
        headers: {
          "Api-Key": config.apiKey,
          "Content-Type": "application/json",
          // "Ocp-Apim-Trace": "true"
        },
        body: JSON.stringify(data),
      }),
      1000
    ).then((response) => {
      if (response.ok) {
        setIsSubmitting(false);
        onHearingRequestComplete();
      }
      else {
        console.error(response.statusText);
        setProcessingError("There was an error submitting your request. Please contact us at 1-888-448-0000 or apt@york.ca.");
        setIsSubmitting(false);
      }
    }).catch((err) => {
      console.error(err);
      setProcessingError("There was an error submitting your request. Please contact us at 1-888-448-0000 or apt@york.ca.");
      setIsSubmitting(false);
    });
  };

  return (
    <div className="path-webform">
      
      <form
        className="webform-submission-form webform-submission-add-form webform-submission-test-form webform-submission-test-add-form js-webform-details-toggle webform-details-toggle antibot contextual-region"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="webform-flexbox js-webform-flexbox js-form-wrapper form-wrapper" style={{marginTop:'1rem'}}>
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <FormInput
                id="actor"
                label="I am"
                type="radio"
                register={register("actor", {required: "This is required"})}
                error={errors.actor}
                options={[{value:'owner',label:"The Vehicle Plate Owner identified on the penalty order"},{value:'authorized',label:"Authorized to act on behalf of the Vehicle Plate Owner"}]}
                required
              />
            </div>
          </div>
        </div>

        <Actor
          type="owner"
          readonly={true}
          register={register}
          control={control}
          errors={errors}
          setValue={setValue}
        />

        {actor === "authorized" && (
          <Actor
            type="authorized"
            register={register}
            control={control}
            errors={errors}
            setValue={setValue}
          />
        )}

        <div className="webform-flexbox js-webform-flexbox js-form-wrapper form-wrapper" style={{marginTop:'1rem'}}>
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <FormInput
                id="requestReason"
                label="Reason for Challenge"
                description="Clarify your reason for challenging: Clearly state why you believe the Screening officer's decision is unreasonable. (Example: The decision was unreasonable due to the following)"
                descriptionLocation="before"
                type="textarea"
                maxLength={2000}
                register={register("requestReason", {required: "A reason for the request is required"})}
                error={errors.requestReason}
                required
              />
            </div>
          </div>
        </div>

        <div className="webform-flexbox js-webform-flexbox js-form-wrapper form-wrapper" style={{marginTop:'1rem'}}>
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">

              <div class="js-form-item form-item">
                <label className="form-item__label">Hearing Method</label>
                <div class="value">Virtual/Phone</div>
              </div>

              <div className="description">
                <div className="webform-element-description">We will contact you to select and confirm a hearing date/time.</div>
                <div className="webform-element-description">As per section 9 of the Statutory Powers Procedure Act your screening and/or hearing review may be open to the public.</div>
              </div>
            </div>
          </div>
        </div>

        { drupalSettings?.apt_config?.terms_of_service_url &&
          <div
            className="webform-flexbox js-webform-flexbox js-form-wrapper form-wrapper"
            style={{ marginTop: "1rem" }}
          >
            <div className="webform-flex webform-flex--1">
              <div className="webform-flex--container">
                <FormInput
                  id="termsOfService"
                  label="I have read and agree to the Terms of Service"
                  type="checkbox"
                  register={register("termsOfService", {
                    required: "You must agree to the terms of service",
                  })}
                  error={errors.termsOfService}
                  required
                />
                <div className="description">
                  <div className="webform-element-description">Read terms of service <a href="/" target="_blank">here</a></div>
                </div>
              </div>
            </div>
          </div>
        }

        <div className="webform-flex--1 js-form-item form-item js-form-type-textfield form-type-textfield">
          <button
            id="submitButton"
            className="webform-button--submit button button--secondary js-form-submit form-submit"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
        { processingError && <h3 className="request-processing-error">{processingError}</h3> }
      </form>
      {isSubmitting && <LoadingOverlay label={isUploading ? `Uploading ${isUploading}` : 'Submitting Request'} />}
    </div>
  );
}
